// Felvételi információk linkje - Multiple choice
export const FELVETELI_INFO_LINK_OPTIONS = {
    hu: [
        { value: 'egyetemi_honlap', label: 'Egyetemi honlap (www.uni.sze.hu)' },
        { value: 'kari_honlap', label: 'Kari honlap' },
        { value: 'felveteli_portal', label: 'Felvételi portál (felveteli.sze.hu)' },
        { value: 'szak_specifikus_oldal', label: 'Szak-specifikus oldal' },
        { value: 'kozossegi_media', label: 'Közösségi média (Facebook, Instagram, TikTok)' },
        { value: 'youtube_csatorna', label: 'YouTube csatorna' },
        { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
        { value: 'egyetemi_honlap', label: 'University website (www.uni.sze.hu)' },
        { value: 'kari_honlap', label: 'Faculty website' },
        { value: 'felveteli_portal', label: 'Admissions portal (felveteli.sze.hu)' },
        { value: 'szak_specifikus_oldal', label: 'Programme-specific webpage' },
        { value: 'kozossegi_media', label: 'Social media (Facebook, Instagram, TikTok)' },
        { value: 'youtube_csatorna', label: 'YouTube channel' },
        { value: 'egyeb', label: 'Other:' }
    ]
};

// Információk minősége - Radio buttons
export const INFORMACIO_MINOSEG_OPTIONS = {
    hu: [
        { value: 'elerheto_naprakesz', label: 'Átfogó, naprakész információk' },
        { value: 'megfelelo_fejlesztheto', label: 'Megfelelő, de fejleszthető' },
        { value: 'hianyos_frissitesre_szorul', label: 'Hiányos, frissítésre szorul' }
    ],
    en: [
        { value: 'elerheto_naprakesz', label: 'Comprehensive and up-to-date information' },
        { value: 'megfelelo_fejlesztheto', label: 'Adequate, but with scope for improvement' },
        { value: 'hianyos_frissitesre_szorul', label: 'Incomplete, requires updating' }
    ]
};

// Használt közösségi média platformok - Multiple choice
export const KOZOSSEGI_MEDIA_PLATFORMOK_OPTIONS = {
    hu: [
        { value: 'facebook', label: 'Facebook' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'linkedin', label: 'LinkedIn' },
        { value: 'youtube', label: 'YouTube' },
        { value: 'twitter_x', label: 'Twitter/X' },
        { value: 'wechat', label: 'WeChat' },
        { value: 'nincs_jelenet', label: 'Nincs közösségi média jelenlét' },
        { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
        { value: 'facebook', label: 'Facebook' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'linkedin', label: 'LinkedIn' },
        { value: 'youtube', label: 'YouTube' },
        { value: 'twitter_x', label: 'Twitter/X' },
        { value: 'wechat', label: 'WeChat' },
        { value: 'nincs_jelenet', label: 'No social media presence' },
        { value: 'egyeb', label: 'Other:' }
    ]
};

// Közösségi média stratégia értékelése - Radio buttons
export const KOZOSSEGI_MEDIA_STRATEGIA_OPTIONS = {
    hu: [
        { value: 'aktiv_hatekony', label: 'Aktív, hatékony jelenlét' },
        { value: 'kozepes_aktivitas', label: 'Közepes aktivitás' },
        { value: 'alacsony_fejlesztesre_szorul', label: 'Alacsony aktivitás, fejlesztésre szorul' },
        { value: 'nincs_strukturalt', label: 'Nincs strukturált stratégia' }
    ],
    en: [
        { value: 'aktiv_hatekony', label: 'Active and effective presence' },
        { value: 'kozepes_aktivitas', label: 'Moderate level of activity' },
        { value: 'alacsony_fejlesztesre_szorul', label: 'Low level of activity, requires improvement' },
        { value: 'nincs_strukturalt', label: 'No structured strategy in place' }
    ]
};

// Egyeztetés Kommunikációért és Sajtókapcsolatokért Felelős Igazgatósággal - Radio buttons
export const KOMMUNIKACIO_IGAZGATOSAG_EGYEZTETES_OPTIONS = {
    hu: [
        { value: 'rendszeres', label: 'Rendszeres egyeztetés történt' },
        { value: 'alkalmi', label: 'Alkalmi egyeztetés történt' },
        { value: 'nem_tortent', label: 'Nem történt egyeztetés' }
    ],
    en: [
        { value: 'rendszeres', label: 'Regular coordination took place' },
        { value: 'alkalmi', label: 'Occasional coordination took place' },
        { value: 'nem_tortent', label: 'No coordination took place' }
    ]
};

// Egyeztetés Szolgáltatási és Brand Igazgatósággal - Radio buttons
export const SZOLGALTATASI_IGAZGATOSAG_EGYEZTETES_OPTIONS = {
    hu: [
        { value: 'rendszeres', label: 'Rendszeres egyeztetés történt' },
        { value: 'alkalmi', label: 'Alkalmi egyeztetés történt' },
        { value: 'nem_tortent', label: 'Nem történt egyeztetés' }
    ],
    en: [
        { value: 'rendszeres', label: 'Regular coordination took place' },
        { value: 'alkalmi', label: 'Occasional coordination took place' },
        { value: 'nem_tortent', label: 'No coordination took place' }
    ]
};

// Kommunikációs aktivitás értékelése - Radio buttons
export const KOMMUNIKACIOS_AKTIVITAS_OPTIONS = {
    hu: [
        { value: 'proaktiv_rendszeres', label: 'Proaktív, rendszeres kommunikáció' },
        { value: 'reaktiv_esemenyvezérelt', label: 'Reaktív, eseményvezérelt kommunikáció' },
        { value: 'alkalmi_szorványos', label: 'Alkalmi, szórványos kommunikáció' },
        { value: 'alacsony', label: 'Alacsony kommunikációs aktivitás' }
    ],
    en: [
        { value: 'proaktiv_rendszeres', label: 'Proactive, regular communication' },
        { value: 'reaktiv_esemenyvezérelt', label: 'Reactive, event-driven communication' },
        { value: 'alkalmi_szorványos', label: 'Occasional, ad hoc communication' },
        { value: 'alacsony', label: 'Low level of communication activity' }
    ]
};
